import { Link, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { Button } from "./ui";

export function Layout() {
  const { user, logout } = useAuthStore();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-slate-800 bg-slate-900/80 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3">
          <Link to="/" className="text-lg font-bold text-white">
            WishList Hub
          </Link>
          <nav className="flex flex-wrap items-center gap-2 text-sm">
            <Link to="/create" className="text-slate-400 hover:text-white">
              Новый список
            </Link>
            {user ? (
              <>
                <Link to="/profile" className="text-slate-400 hover:text-white">
                  Профиль
                </Link>
                <Link to="/profile/wishlists" className="text-slate-400 hover:text-white">
                  Мои списки
                </Link>
                <Button variant="ghost" className="!py-1 !px-2" onClick={() => logout()}>
                  Выйти
                </Button>
              </>
            ) : (
              <>
                <Link to="/auth/login" className="text-slate-400 hover:text-white">
                  Вход
                </Link>
                <Link to="/auth/register">
                  <Button variant="secondary" className="!py-1 !px-3">
                    Регистрация
                  </Button>
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
